import React from "react";
import KeywordsTag from './KeywordsTag';

const Europe = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="europe"
        handwritingSrc="../../content/handwriting/europe.png"
        handwritingAlt="europe"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default Europe;